import { inject, Injectable, signal } from '@angular/core';
import { IStopAddress } from '@okcargo-apps/shared-domain';
import { IAddressBookEntry } from '@okcargo-apps/shared-domain-ionic';
import {
  AddressbookQueryService,
  mapFromAddressBookResponse,
  mapFromPlaceAddressResponse,
} from '@okcargo-apps/shared-infrastructure-ionic';

@Injectable({
  providedIn: 'root',
})
export class AddressbookService {
  private readonly _loading = signal<boolean>(false);
  private readonly _adresses = signal<IAddressBookEntry[]>([]);

  private readonly addressbookQueryService = inject(AddressbookQueryService);

  public readonly loading = this._loading.asReadonly();
  public readonly adresses = this._adresses.asReadonly();

  // constructor() {}

  public async searchAddresses(term: string): Promise<void> {
    if (!term || term.length <= 2) {
      this._loading.set(false);
      this._adresses.set([]);
      return;
    }

    this._loading.set(true);

    try {
      const paramsForAddressees = {
        page: 0,
        size: 5,
        sort: ['streetAddress', 'asc'],
        'streetAddress.contains': term,
      };

      const response = await this.addressbookQueryService.search(paramsForAddressees, term);

      if (response) {
        const results: IAddressBookEntry[] = response.map(mapFromAddressBookResponse);
        this._adresses.set(results);
      } else {
        this._adresses.set([]);
      }
    } catch (error) {
      console.error('Error searching in address book:', error);
      this._adresses.set([]);
    } finally {
      this._loading.set(false);
    }
  }

  public async findAddressByPlaceId(placeId: string | number): Promise<IStopAddress> {
    try {
      const result = await this.addressbookQueryService.findByPlaceId(placeId);
      return mapFromPlaceAddressResponse(result);
    } catch (error) {
      console.error('Error finding address by placeId:', error);
      return {} as IStopAddress;
    }
  }

  public clearAddresses(): void {
    this._adresses.set([]);
  }
}
